// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__ltlpY","dropdownPopover":"styles_dropdown-popover__EQMkG"};